<template>
  <v-container>
    <v-row class="pt-10" justify="center">
      <v-col cols="11">
        <v-sheet outlined rounded="lg">
          <v-row class="pa-4" justify="center" align="center">
            <v-col cols="2">
              <v-img
                src="https://drive.google.com/uc?export=view&id=1ayHBNWo0evV1zybw2TLy1kds6AORxjVc"
              >
              </v-img>
            </v-col>
            <v-col cols="9">
              <v-row class="mx-0">
                <span class="subtitle-1 primary-variant font-weight-black">
                  Registra los datos del nuevo afiliado vinculado
                </span>
                <br />
                <span class="body-2 primary-variant mt-2">
                  Luego de Registrar los datos para el nuevo afiliado vinculado,
                  deberás cubrir las cuotas para el pago local y nacional
                </span>
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="3" class="mx-1 pa-0 my-1">
              <v-text-field
                solo
                dense
                hide-details="auto"
                v-model="newAffiliate.user.name"
              >
                <template v-slot:label>
                  <span class="caption"> Nombres </span>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3" class="mx-1 pa-0 my-1">
              <v-text-field
                solo
                dense
                hide-details="auto"
                v-model="newAffiliate.user.firstLastname"
              >
                <template v-slot:label>
                  <span class="caption"> Apellidos </span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="3" class="mx-1 pa-0 my-1">
              <v-text-field
                solo
                dense
                hide-details="auto"
                v-model="newAffiliate.user.email"
              >
                <template v-slot:label>
                  <span class="caption"> Email </span>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="3" class="mx-1 pa-0 my-1">
              <v-text-field
                solo
                dense
                hide-details="auto"
                v-model="newAffiliate.user.position"
              >
                <template v-slot:label>
                  <span class="caption"> Cargo / Posición </span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <!-- Divider between fixed and custom fields -->
          <template v-if="subMemberFormFields.length > 0">
            <v-row justify="center" class="mt-2 mb-0">
              <v-col cols="6" class="px-1 py-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row justify="center" class="mb-1">
              <v-col cols="6" class="px-1 pt-1 pb-0 d-flex align-center">
                <v-icon x-small color="grey darken-1" class="mr-1">mdi-tune</v-icon>
                <span class="caption grey--text text--darken-1">Campos adicionales</span>
              </v-col>
            </v-row>
          </template>

          <!-- Custom fields configured by admin for sub-member form -->
          <v-row
            v-for="field in subMemberFormFields"
            :key="field._id"
            justify="center"
          >
            <v-col cols="6" class="mx-1 pa-0 my-1">
              <!-- LIST type -->
              <v-select
                v-if="field.fieldType === 'LIST'"
                solo
                dense
                hide-details="auto"
                :items="field.options"
                :multiple="field.allowMultiple"
                v-model="customFieldsData[field.formattedName]"
              >
                <template v-slot:label>
                  <span class="caption">
                    {{ field.name }}<span v-if="field.required" class="red--text"> *</span>
                  </span>
                </template>
              </v-select>
              <!-- NUMBER type -->
              <v-text-field
                v-else-if="field.fieldType === 'NUMBER'"
                solo
                dense
                hide-details="auto"
                type="number"
                v-model="customFieldsData[field.formattedName]"
              >
                <template v-slot:label>
                  <span class="caption">
                    {{ field.name }}<span v-if="field.required" class="red--text"> *</span>
                  </span>
                </template>
              </v-text-field>
              <!-- DATE type -->
              <v-text-field
                v-else-if="field.fieldType === 'DATE'"
                solo
                dense
                hide-details="auto"
                type="date"
                v-model="customFieldsData[field.formattedName]"
              >
                <template v-slot:label>
                  <span class="caption">
                    {{ field.name }}<span v-if="field.required" class="red--text"> *</span>
                  </span>
                </template>
              </v-text-field>
              <!-- TEXT / default type -->
              <v-text-field
                v-else
                solo
                dense
                hide-details="auto"
                v-model="customFieldsData[field.formattedName]"
              >
                <template v-slot:label>
                  <span class="caption">
                    {{ field.name }}<span v-if="field.required" class="red--text"> *</span>
                  </span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row class="mx-4 py-8" justify="end">
            <v-btn small rounded text class="mr-2" @click="$emit('cancel')">
              <span class="caption"> Cancelar </span>
            </v-btn>
            <v-btn
              small
              rounded
              color="primary"
              class="white--text mr-2"
              @click="AddAffiliate(false)"
            >
              <span class="caption"> Crear y salir </span>
              <v-icon size="14" class="ml-2"> mdi-content-save </v-icon>
            </v-btn>
            <v-btn
              v-if="disableSubmemberPayment"
              small
              rounded
              color="primary"
              class="white--text"
              @click="AddAffiliate(true)"
            >
              <span class="caption"> Crear e iniciar pago </span>
              <v-icon size="12" class="ml-2"> mdi-arrow-expand-right </v-icon>
            </v-btn>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { retrieveMemberAffiliationDetails } from "../../../../common/hook/useHelper";
export default {
  name: "RegisterForm",
  data() {
    return {
      newAffiliate: {
        user: {
          name: "",
          firstLastname: "",
          email: "",
          position: "",
        },
        customFields: {},
      },
      subMemberFormFields: [],
      customFieldsData: {},
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("membershipProfile", ["userMembership"]),
    disableSubmemberPayment() {
      const { affiliationType: nationalAffiliationDetails } = retrieveMemberAffiliationDetails({
        user: this.user,
        affiliationLevel: "national",
      });

      return !!nationalAffiliationDetails?.sublevelPriceConfig?.active
    },
  },
  async created() {
    try {
      const orgId = this.user?.headOffice?._id || this.user?.headOffice;
      if (orgId) {
        const result = await this.getSubMemberFormFields(orgId);
        if (result.status) {
          this.subMemberFormFields = result.data.registrationFields || [];
        }
      }
    } catch (e) {
      console.error('Error loading sub-member form fields', e);
    }
  },
  methods: {
    ...mapActions("memberAffiliates", [
      "getAffiliates",
      "addAffiliate",
      "deleteAffiliate",
      "updateAffiliate",
    ]),
    ...mapActions("user", ["realoadUserData"]),
    ...mapActions("registrationFields", ["getSubMemberFormFields"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("notification", ["show"]),

    async AddAffiliate(continuePayment) {
      try {
        this.loading();

        // Build customFields from dynamic form values
        const customFields = {};
        this.subMemberFormFields.forEach(field => {
          const val = this.customFieldsData[field.formattedName];
          if (val !== undefined && val !== null && val !== '') {
            customFields[field.formattedName] = val;
          }
        });
        this.newAffiliate.customFields = customFields;

        const affiliate = await this.addAffiliate({
          affiliate: this.newAffiliate,
          organization: this.user.headOffice._id,
          branch: this.userMembership ? this.userMembership?.organization._id : null,
        });
        console.log(affiliate);
        if (affiliate.status) {
          this.show({ text: "Afiliado creado exitosamente", color: "green" });
          if (continuePayment) {
            const user = affiliate.affiliate;
            this.$router.push(
              `/member/newAffiliate/2/${user._id}/${this.userMembership.organization._id}`
            );
          } else {
            //await this.realoadUserData({ email: this.user.email });
            this.$emit("cancel");
          }
        } else {
          this.show({
            text: affiliate.message,
            color: "red",
          });
          this.$emit("error");
        }
        this.loaded();
      } catch (error) {
        console.log(error);
      } finally {
        this.loaded();
      }
    },
  },
};
</script>

<style></style>